import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authGuardModuleOpenAI, authGuardModuleTrendGPT } from "lib-trend-core";
import { AgentOpenAIAssistantFormComponent } from "./agent-openai/agent-openai-assistant-form/agent-openai-assistant-form.component";
import { AgentOpenAIAssistantsComponent } from "./agent-openai/agent-openai-assistants/agent-openai-assistants.component";
import { AgentOpenAIIntegrationFormComponent } from "./agent-openai/agent-openai-integration-form/agent-openai-integration-form.component";
import { AgentOpenAIComponent } from "./agent-openai/agent-openai.component";
import { AgentTrendgptFormComponent } from "./agent-trendgpt/agent-trendgpt-form/agent-trendgpt-form.component";
import { AgentTrendgptComponent } from "./agent-trendgpt/agent-trendgpt.component";
import { AgentsComponent } from "./agents.component";

const routes: Routes = [
  { path: '', component: AgentsComponent, canActivate: [authGuardModuleTrendGPT] },
  { path: 'trendgpt', component: AgentTrendgptComponent, canActivate: [authGuardModuleTrendGPT] },
  { path: 'trendgpt/create', component: AgentTrendgptFormComponent, canActivate: [authGuardModuleTrendGPT] },
  { path: 'trendgpt/:id/edit', component: AgentTrendgptFormComponent, canActivate: [authGuardModuleTrendGPT] },

  // OpenAI
  { path: 'openai', component: AgentOpenAIComponent, canActivate: [authGuardModuleOpenAI] },
  { path: 'openai/integration/create', component: AgentOpenAIIntegrationFormComponent, canActivate: [authGuardModuleOpenAI] },
  { path: 'openai/integration/:id/edit', component: AgentOpenAIIntegrationFormComponent, canActivate: [authGuardModuleOpenAI] },
  { path: 'openai/:id/assistants', component: AgentOpenAIAssistantsComponent, canActivate: [authGuardModuleOpenAI] },
  { path: 'openai/:id/assistant/create', component: AgentOpenAIAssistantFormComponent, canActivate: [authGuardModuleOpenAI] },
  { path: 'openai/:id/assistant/:assistantId/edit', component: AgentOpenAIAssistantFormComponent, canActivate: [authGuardModuleOpenAI] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class AgentsRoutingModule { }
